<template>
  <div class="card shadow-sm mb-4 border-0 search-table-container">
    <b-link class="heading-container" :class="{'no-code': codes.length === 0}" v-b-toggle="`search-table-${code}`">
      <h5>
        HSN Code
        <b-link :to="{name: 'hsCode', params: {id: code}}">
          <b>{{ code }}</b>
        </b-link>
        <b-icon icon="chevron-down" class="h6 mb-1 ml-2" v-show="(isFirst ? !show : show) && codes.length > 0"></b-icon>
        <b-icon icon="chevron-up" class="h6 mb-1 ml-2" v-show="(isFirst ? show : !show) && codes.length > 0"></b-icon>
      </h5>
      <p class="mb-1">
        {{ eights.desc }}
      </p>
    </b-link>
    <b-collapse :id="`search-table-${code}`" @input="show = !show" :visible="isFirst" v-if="codes.length > 0">
      <div class="search-table">
        <b-table bordered hover :items="codes" class="mb-0">
          <template v-slot:cell()="data">
            <b>{{ data.value }}</b>
          </template>
          <template v-slot:cell(Description)="data">
            {{ data.value }}
          </template>
          <template v-slot:cell(GST%)="data">
            <b>{{ data.value }}%</b>
          </template>
        </b-table>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: ['eights', 'code', 'isFirst'],
  data: () => ({
    show: false
  }),
  computed: {
    codes () {
      return this.eights.codes.map(item => {
        return {
          'HS Code': Object.keys(item)[0],
          Description: Object.values(item)[0],
          'GST%': this.eights.gst
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.search-table-container {
  .heading-container {
    text-decoration: none;
    color: black;
    border: 1px solid $gray-100;
    position: relative;
    top: 1px;
    padding: 1rem 0.75rem;
    &:hover {
      background-color: $light-blue;
    }
    &.no-code {
      cursor: auto;
      &:hover {
        background-color: transparent;
      }
    }
  }
  .heading {
    line-height: 2rem;
    margin-bottom: 1rem;
  }
}
</style>
